import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
} from 'react';

export type FormConfigurationContextType = {
  isReadOnlyInput: boolean
}

const defaultFormConfigurationContext: FormConfigurationContextType = {
  isReadOnlyInput: false,
};

export const FormConfigurationContext = createContext(defaultFormConfigurationContext);

export function useFormConfigurationContext(disabled: boolean = false) {
  const { isReadOnlyInput } = useContext(FormConfigurationContext);

  return {
    isDisabled: disabled || isReadOnlyInput,
  };
}

export function FormConfigurationProvider({ children, ...props }: PropsWithChildren<FormConfigurationContextType>) {
  const contextValue = useMemo(() => ({ ...props }), [props]);

  return (
    <FormConfigurationContext.Provider value={contextValue}>
      {children}
    </FormConfigurationContext.Provider>
  );
}
